import {
  extractScreenTypeFromUrl,
  replaceRetiredScreenType,
  type MarlinStore,
} from "@observe-tech/marlin-store/core";

const BOOT_PATH = "/boot";
const BOOT_SCREEN_TYPE = "boot";

const urlForScreenType = (screenType: string): string => {
  const hashIndex = screenType.indexOf("#");
  const path = (hashIndex === -1 ? screenType : screenType.slice(0, hashIndex))
    .replace(/^\/+/, "")
    .trim();
  const hash = hashIndex === -1 ? "" : screenType.slice(hashIndex);
  return `/${path}${window.location.search}${hash}`;
};

export const restoreWindows = async (store: MarlinStore): Promise<void> => {
  const screens = await store.screens.getScreens();

  if (window.location.pathname === BOOT_PATH) {
    const persisted = screens.find(
      (screen) => screen.id === store.screenId,
    )?.screenType;

    if (persisted)
      history.replaceState(
        history.state,
        "",
        urlForScreenType(replaceRetiredScreenType(persisted)),
      );
  }

  const windows = store.capabilities.windows;
  if (!windows) return;

  const missing = screens
    .filter((screen) => screen.isShowing && screen.id !== store.screenId)
    .map((screen) => screen.id);
  if (missing.length === 0) return;

  void windows
    .open(missing)
    .catch((error) => console.warn("[shell] opening screens failed", error));
};

export const createScreenTypeRecorder = (
  store: MarlinStore,
): ((href: string) => void) => {
  let writes = Promise.resolve();

  const write = async (screenType: string) => {
    if ((await store.screens.getScreen()).screenType === screenType) return;
    await store.screens.updateScreenType(screenType);
  };

  return (href) => {
    const screenType = extractScreenTypeFromUrl(href);
    if (!screenType || screenType === BOOT_SCREEN_TYPE) return;
    writes = writes
      .then(() => write(screenType))
      .catch((error) =>
        console.warn("[shell] recording the screen type failed", error),
      );
  };
};
